import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
export function NavPathname(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const t1 = usePathname();
  let t2;
  if ($[0] !== children || $[1] !== t1) {
    t2 = children(t1);
    $[0] = children;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}